import React, { useCallback, useEffect, useState } from 'react';

import { PROCESSOR_ERROR_CODES } from '../../constants/processors';
import couch from '../../assets/eila-on-the-couch2.jpg';
import { buildAnchorCheckoutLink, buildAnchorLink } from '../../utils/helpers';


import EmailInfo from './CheckoutComponents/EmailInfo';

const ERROR_MESSAGES = {
  ACCOUNT_CREATION_ERROR: 'creating your account',
  FANCLUB_PURCHASE_ERROR: 'trying to create your anchor subscription',
  MEMBERSHIP_PURCHASE_ERROR: 'creating your membership',
};


function FailMessage(props) {
  const {
    purchaseId,
    processorId,
    productType1,
    transactionId,
    errorCode,
    errorMessage,
    anchor,
    searchParams,
    user,
  } = props;
  const [error, setError] = useState('');

  const failedTransactionId = transactionId || purchaseId;

  const getAccountErrorMessage = useCallback(() => {
    switch (productType1) {
      case 'MEMBERSHIP':
        return ERROR_MESSAGES.MEMBERSHIP_PURCHASE_ERROR;
      case 'FANCLUB':
        return ERROR_MESSAGES.FANCLUB_PURCHASE_ERROR;
      default:
        return ERROR_MESSAGES.ACCOUNT_CREATION_ERROR;
    }
  }, [productType1]);

  useEffect(() => {
    if (user?.authenticated) {
      setError(getAccountErrorMessage());
    } else {
      setError(ERROR_MESSAGES.ACCOUNT_CREATION_ERROR);
    }
  }, [getAccountErrorMessage, processorId, user, user?.authenticated]);

  const getURLToPaymentPage = useCallback(() => {
    const anchorCheckoutLink = buildAnchorCheckoutLink(anchor?.id, buildAnchorLink(anchor));
    if (productType1 === 'FANCLUB' && anchor.id) {

      return `${anchorCheckoutLink}&${searchParams.replace('?', '')}`;
    }

    if (productType1 === 'MEMBERSHIP') {
      return `/account/purchase${searchParams}`;
    }

    if ((productType1 === 'GIFT' || productType1 === 'ITEM') && anchor.id) {
      return `${buildAnchorLink(anchor)}${searchParams}`;
    }
  }, [anchor, productType1, searchParams]);

  const getErrorMessage = useCallback(() => {
    if (errorMessage) {
      return errorMessage;
    }

    return PROCESSOR_ERROR_CODES[errorCode] ? PROCESSOR_ERROR_CODES[errorCode] : 'Unknown.';
  }, [errorCode, errorMessage]);

  const ContactEmail = useCallback(() => {
    if (errorCode !== 'MYNEGDB') {
      return (
        <>
          Please contact customer support for more information&nbsp;
          <a href="mailto:support@nakednews.com">support@nakednews.com
          </a>
        </>
      );
    }

    return (
      <>
        Email: <a href="mailto:Billing@billingsupport.com">Billing@billingsupport.com</a><br />
        Website: <a href="https://epoch.com" rel="noreferrer" target="_blank">Epoch.com</a><br />
        Phone Number: 1-800-893-8871<br />
        Int. Tel.: 1-310-664-5810<br />
        Skype: Toll Free: 1-800-893-8871<br />
      </>
    );

  }, [errorCode]);

  return (
    <div className="content">
      <div className="container">
        <div className="card">
          <div className="row">
            <div className="col-xs-12 col-sm-5">
              <img alt="Naked News" className="full" src={couch} />
            </div>
            <div className="col-xs-12 col-sm-7">
              <div className="card-content" id="payment-fail">
                <h2>A problem occurred while {error}!</h2>
                <p className="lead">
                  It looks like something went wrong while {error}.
                  <br />Reason:
                  <b>
                    <p className="billing-fail-error-msg">{getErrorMessage(errorCode, errorMessage)}</p>
                  </b>
                  <br />
                  <ContactEmail />
                </p>
                <p className="lead">
                  When contacting customer support please provide this ID: <b>{failedTransactionId}</b>
                </p>
                <p className="lead">
                  Please click here to <a className="btn btn-red retry-btn" href={getURLToPaymentPage()}>TRY AGAIN!</a>
                </p>
                <EmailInfo />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FailMessage;
